import axios from 'axios'
import Qs from 'qs'
import router from '../../../router'
import logout from '../../../shared/logout'

const initialState = {
  // Search State
  results: null,
  initialResults: null,
  searching: false,
  productView: 'grid',
  // Singular Product
  activeProduct: null,
  productLoading: false,
  recentlyViewed: [],
  showFavPanel: false,
  categories: [],
  quickPadPasteLoading: false,
  errorMsg: false,
  similarProducts: [],
  similarLoading: false
}

const processBranches = function(product){
  let base = _.reject(product.eclipse_data.branches, {id: ''})
  return base
}

// Scroll main content window back to top 
const scrollToTop = ()=>{
  const content = document.getElementById('content')
  if(content) content.scrollTo(0,0)
}

export const productStore = {
  state: {...initialState},
  mutations:{
    resetState(state){
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setResults(state, data){
      state.results = data
    },
    searchStatus(state, status){
      state.searching = status
    },
    setCategories(state, categories){
      state.categories = categories
    },
    setCategoryData(state, data){
      state.activeCategory = data.category
      if(data.type == 'sub'){
        state.activeSubCategory = data.name
      }else{
        state.activeSubCategory = null
      }
    },
    setProductLoadState(state, status){
      state.productLoading = status
    },
    setActiveProduct(state, product){
      // Populate recently viewed array
      const match =  _.find(state.recentlyViewed, p => p.product_id == product.product_id)
      if(state.recentlyViewed.length >= 12){
        if(!match){
          state.recentlyViewed.shift()
          state.recentlyViewed.push(product)
        }
      }else{
        if(!match){
          state.recentlyViewed.push(product)
        }
      }
      product.eclipse_data.branches = processBranches(product)
      state.activeProduct = product
    },
    resetActiveProduct(state){
      state.activeProduct = null
    },
    setProductView(state, view){
      state.productView = view
      scrollToTop()
    },
    setShowFav(state, status){
      state.showFavPanel = status
    },
    updateCustomerPartNumber(state, record){
      let match = _.find(state.results.products, p => p.product_id == record.product_id)
      match.customer_part_number = record
    },
    deleteCustomerPartNumber(state, data){
      let match = _.find(state.results.products, p => p.product_id == data.product_id)
      match.customer_part_number = null
    },
    setQuickPadPasteLoading(state, status){
      state.quickPadPasteLoading = status
    },
    setError(state, error){
      state.errorMsg = error
    },
    setSimilarProducts(state, products){
      state.similarProducts = products
    },
    setSimilarLoadState(state, status){
      state.similarLoading = status
    },
    appendProductData(state, data){
      // set base
      const ids = _.map(data.results.products, 'eclipse_id')
      const requestIds = _.map(data.params.products, p => parseInt(p))
      let set = _.filter(state.results.products, p => ids.includes(p.product_id))
    
      // Append Data
      set.forEach(p=>{
        p.eclipse_data = _.find(data.results.products, e => e.eclipse_id == p.product_id)
        p.promo = _.find(data.results.promos, promo => promo.product_id == p.product_id)
        p.show_details = _.filter(data.results.vshow, v => v.product_id == p.product_id)
        p.show_vendor_terms = _.find(data.results.vshow_vendor_terms, v => v.vendor_name == p.mfg)
        p.inbound_inventory = _.filter(data.results.inbound_inventory, i => i.product_id == p.product_id)
        p.customer_part_number = _.find(data.results.part_numbers, pn => pn.product_id == p.product_id)
        p.prepaid_freight_exclusion = _.find(data.results.prepaid_freight_exclusions, ppf => ppf.product_id == p.product_id)
        p.in_vshow = data.results.in_vshow?.includes(p.product_id)
        p.product_message = _.find(data.results.product_messages, pm => pm.product_id == p.product_id)
      })

      // Check for eclipse misses (requested vs provided data) and refetch data for missed products
      const diff = _.xor(requestIds, ids)
      if(diff.length){
        const params = {products: diff}
        this.dispatch('getProductData', params)
      }
      
    }
  },
  actions:{
    productResetState(context){
      context.commit('resetState')
    },
    // Get Categories for menu
    getCategories(context){
      const params = {
        route: router.currentRoute.value.path
      }
      axios.get('/api/v1/private/product/get_categories', {params})
      .then(res =>{
        if(res.status == 200){
          context.commit('setCategories', res.data.categories)    
        }
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    getSearchProducts(context, params){
      context.commit('setProductLoadState', true)
      // Close mobile filter menu when searching
      this.dispatch('getFavorites')
      // Inject Merit Supply product filter
      if(this.state.sessionStore.company == 'Merit Supply'){
        params = {...params, meritSupply: this.state.sessionStore.meritSupply}
      }
      // Perform search
      axios.get('/api/v1/private/product/search', {params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'brackets'})})
      .then(res => {
        if(res.data.results?.error){
          router.push({path: '/'})
        }else if(res.data.error && res.data.error == 'No User'){
          logout()
        }else{
          context.commit('setError', null)
          context.commit('setResults', res.data.results)
          this.dispatch('setFilters', res.data.results)
          context.commit('setProductLoadState', false)
        }
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    getProductData(context, params){
      axios.get('/api/v1/private/product/get_product_data', {params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'brackets'})})
      .then(res=>{
        // Append in DropshipStore
        if(res.data.params.route == '/dropship_hub'){
          this.dispatch('dropshipAppendProductData', res.data)
        }else{
          context.commit('appendProductData', res.data)
        }
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    getProduct(context, params){
      context.commit('setProductLoadState', true)
      context.commit('setSimilarLoadState', true)
      axios.get('/api/v1/private/product/get_product', {params})
      .then(res=>{
        context.commit('setError', null)
        context.commit('setActiveProduct', res.data.product)
        context.commit('setProductLoadState', false)
      })
      .catch(error=>{
        console.error("Error:", error)
        context.commit('resetActiveProduct')
        context.commit('setError', error.response?.statusText || error.message)
        context.commit('setProductLoadState', false)
        router.push({path: '/'})
      })
    },
    getSimilarProducts(context, data){
      axios.get('/api/v1/private/product/get_similar_products', {params: data, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'brackets'})})
      .then(res=>{
        context.commit('setError', null)
        context.commit('setSimilarProducts', res.data.products)
        context.commit('setSimilarLoadState', false)
      })
      .catch(error=>{
        console.error("Error:", error)
        context.commit('setError', error.response?.statusText || error.message)
        context.commit('setSimilarProducts', [])
        context.commit('setSimilarLoadState', false)
      })
    },
    // Define the search view
    setProductView(context, view){
      context.commit('setProductView', view)
    },
    setActiveProduct(context, product){
      context.commit('setActiveProduct', product)
    },
    setShowFav(context, status){
      context.commit('setShowFav', status)
    },
    // Update the front end after customer part number backend updated
    updateCustomerPartNumber(context, record){
      context.commit('updateCustomerPartNumber', record)
    },
    // remove from front end once deleted on backend
    deleteCustomerPartNumber(context, data){
      context.commit('deleteCustomerPartNumber', data)
    },
    setQuickPadPasteLoading(context, status){
      context.commit('setQuickPadPasteLoading', status)
    },
    submitQuickPadPaste(context, lines){
      context.commit('setQuickPadPasteLoading', true)
      const params = {
        query:{
          action: 'quickPadPaste',
          lines
        }
      }
      axios.post('/api/v1/private/quick_pad/paste_products', params)
      .then(res => {
        const params = {
          productList: res.data.results,
          vShow: false
        }
        this.dispatch('quickPadAdd', params)
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    }
  },
  getters:{
    productResults: state => {return state.results},
    searchStatus: state => {return state.searching},
    productView: state => { return state.productView},
    getCategories: state => {return state.categories},
    getActiveProduct: state => {return state.activeProduct},
    productLoadState: state => {return state.productLoading},
    recentlyViewed: state =>{return _.sortBy(state.recentlyViewed).reverse()},
    showFavPanel: state => {return state.showFavPanel},
    quickPadPasteLoading: state => {return state.quickPadPasteLoading},
    similarProducts: state => {return state.similarProducts},
    similarLoadState: state => {return state.similarLoading}
  }
}